<template>
  <div>
    <div v-if="!questionAnswered">
      <div class="px-4 py-5 text-center">
        <session-logo :session="session"></session-logo>

        <h1 class="text-lg font-extralight">{{ generatedQuestion }}</h1>
        <p v-if="question.sub_question" class="text-sm font-extralight">
          {{ question.sub_question }}
        </p>
      </div>

      <form @submit.prevent="submit" novalidate class="max-w-3xl mt-1 px-4 text-center mr-auto ml-auto">
        <div class="bg-white shadow overflow-hidden">
          <ul>
            <li v-for="(choice, idx) in form.choices" :key="idx" @click="select(choice)" class="
                cursor-pointer
                block
                focus:outline-none
                bg-white
                hover:bg-gray-50
                focus:bg-gray-50
                transition
                duration-150
                ease-in-out
              " :class="customClass(choice, idx)">
              <div v-if="choice.type == 'blank'" class="flex items-center px-4 py-2">
                <div class="min-w-0 flex-1 flex items-center">

                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 mr-5"
                    :class="choice.selected ? 'text-white' : 'text-gray-200'">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>

                  <input type="text" v-model="choice.value" @click="handleBlankInputBehaviour(choice, $event)" class="
                      
                              block
                              w-full
                              shadow-sm
                              border-gray-300
                              rounded-md
                              focus:ring-markencode-blue
                              focus:border-markencode-blue
                    " />
                </div>
              </div>

              <div v-if="choice.type == 'set'" class="flex items-center px-4 py-4">
                <div class="min-w-0 flex-1 flex items-center">

                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 mr-5"
                    :class="choice.selected ? 'text-white' : 'text-gray-200'">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>

                  <div class="text-sm leading-5 font-medium truncate"
                    :class="choice.selected ? 'text-white' : 'text-gray-600'">
                    {{ choice.value }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <submit-button :sending="sending" :validated="validated" class="max-w-4xl ml-auto mr-auto mt-4">{{
          translations.save }}</submit-button>
      </form>
    </div>


    <div v-if="questionAnswered" class="mt-6 px-8 py-5 text-center mx-auto">
      <h1 class="text-3xl font-extralight mb-13">
        {{ translations.thank_you }}
      </h1>

      <!-- <div class="border-t border-gray-400 mt-8 mb-8"></div> -->

      <a :href="route('diy-workshops.phase', {
        uuid: participant.uuid,
      })
        "
        class="block mx-auto mt-12 w-min rounded-md border border-transparent px-2 py-3 bg-brandpreneurship-dark-gray  font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 text-sm leading-5 z-50">WEITER</a>
    </div>
  </div>
</template>

<script>
import SubmitButton from '@/Shared/SubmitButton';
import { throttle } from 'lodash';
import SessionLogo from '@/Pages/DiyWorkshop/Shared/SessionLogo';

export default {
  components: {
    SubmitButton,
    SessionLogo,
  },

  props: {
    translations: {},
    participant: {
      required: true,
    },
    question: {
      required: true,
    },
    session: {
      required: true,
      type: Object,
    },
    answerParameters: {},
  },

  data() {
    return {
      sending: false,
      answered: false,
      form: {
        choices: {},
      },
    };
  },

  created() {
    let parameters = this.question.parameters;

    this.form.choices = parameters.choices.map((choice) => {
      return {
        type: 'set',
        value: choice,
        selected: false,
      };
    });

    if (parameters.options.blank_choices) {
      for (let i = 0; i < parameters.options.blank_choices; i++) {
        this.form.choices.unshift({
          type: 'blank',
          value: '',
          selected: false,
        });
      }
    }
  },



  methods: {
    select(choice) {
      if (
        !choice.selected &&
        this.selected >= this.question.parameters.options.max_answers
      ) {
        return;
      }

      this.$set(choice, 'selected', !choice.selected);
    },
    submit() {
      this.sending = true;

      window.axios
        .post(
          this.route('diy-workshops.questions.store', {
            uuid: this.participant.uuid,
            questionId: this.question.id,
          }),
          this.form
        )
        .then(() => {
          this.sending = false;
          // this is an easy way to change the workflow:
          // now after clicking on "save" the user autimatically 
          // lands on the next question
          window.location.reload();
          // this.answered = true;
        })
        .catch((error) => {
          this.sending = false;
        });
    },
    customClass(choice, idx) {
      let classes = '';

      if (idx) {
        classes += 'border-t border-gray-200 ';
      }

      if (choice.selected) {
        classes +=
          'bg-markencode-blue hover:bg-markencode-blue focus:bg-markencode-blue';
      } else {
        classes += 'bg-white hover:bg-gray-50 focus:bg-gray-50';
      }

      return classes;
    },
    handleBlankInputBehaviour(choice, event) {
      if (choice.value) {
        event.stopPropagation();
      }
    },
  },

  computed: {
    generatedQuestion() {

      if (!this.question?.brandname && !this.session.brandname && this.question?.question_default) {
        return this.question?.question_default;
      }

      if (this.question?.is_placeholder_question && (this.question?.brandname || this.session.brandname)) {
        return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
      }

      return this.question.question;
    },

    selected() {
      if (this.form.choices.length) {
        return this.form.choices.filter((choice) => choice.selected).length;
      }

      return 0;
    },
    validated() {
      return (
        this.selected >= 1 &&
        this.selected <= this.question.parameters.options.max_answers
      );
    },
    questionAnswered() {
      return (
        (this.answerParameters && this.answerParameters.choices.length > 0) ||
        this.answered
      );
    },
    // channel() {
    //   return Echo.channel(
    //     'markencode-productivity.session.' + this.participant.markencode_session.id
    //   );
    // },
  },

};
</script>